import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { User } from "@/redux/services/user/user.type";
import {
  Restaurant,
  RestaurantFranchise,
} from "@/redux/services/restaurant/restaurant.type";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    currentUser: {} as User,
    currentRestaurant: {} as Restaurant,
    currentFranchise: {} as RestaurantFranchise,
  },
  reducers: {
    setCurrentUser: (state, action: PayloadAction<User>) => {
      state.currentUser = action.payload;
    },
    setCurrentRestaurant: (state, action: PayloadAction<Restaurant>) => {
      state.currentRestaurant = action.payload;
    },
    setCurrentFranchise: (
      state,
      action: PayloadAction<RestaurantFranchise>
    ) => {
      state.currentFranchise = action.payload;
    },
    /**
     * Owner franchise switcher (SFRESTO-169): selects another franchise and,
     * when it is a different one, drops the current restaurant, which belongs
     * to the previous franchise (back to the franchise-level view).
     */
    switchFranchise: (state, action: PayloadAction<RestaurantFranchise>) => {
      if (state.currentFranchise?.id !== action.payload.id) {
        state.currentRestaurant = {} as Restaurant;
      }
      state.currentFranchise = action.payload;
    },
  },
});

export const {
  setCurrentUser,
  setCurrentRestaurant,
  setCurrentFranchise,
  switchFranchise,
} = userSlice.actions;

export default userSlice.reducer;
